<template>
  <div>
    <div v-if="block" class="hr-footer-message-block"></div>
    <div class="hr-footer-message row text-center">
      <div class="hr-footer-message__container">
        <div class="col-xs-12 hr-footer-message__description">
          <slot></slot>
        </div>
        <div class="col-xs-12 hr-footer-message__button">
          <co-button
            class="hr-blue-button"
            data-test-id="hr-button-footer"
            @click="click"
            type="primary"
            >{{ button }}</co-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CoButton } from '@deputy/copilot2';

export default {
  name: 'hrfooter-message',
  components: { CoButton },
  props: {
    button: {
      type: String,
      default: null,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup(_, { emit }) {
    function click() {
      emit('click');
    }

    return {
      click,
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/core/style-vars.scss';

.hr-footer-message-block {
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  position: fixed;
  z-index: 9;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
}

.hr-footer-message {
  transition: all 0.5s ease;
  width: 100%;
  left: 0;
  bottom: 0;
  position: fixed;
  z-index: 10;
  background-color: $early-dawn-background;
  margin: 0;
  padding: 15px 0;

  @media only screen and (max-width: 768px) {
    padding: 0;
  }
}

.hr-footer-message__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hr-footer-message__description {
  font-size: 24px;
  font-weight: 600;
  padding: $footer-padding;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    font-size: 16px;
    font-weight: 600;
    height: $footer-height;
  }
}

.hr-footer-message__button {
  padding: $footer-padding;
}

.hr-footer-message__button .hr-blue-button {
  font-size: 16px;
  font-weight: normal;
}

.hr-footer-message__button .hr-blue-button {
  @media only screen and (max-width: 768px) {
    height: 40px !important;
    width: 110px !important;
  }
}
</style>
